import { render, staticRenderFns } from "./order-image-preview.vue?vue&type=template&id=0da6bc12&scoped=true"
import script from "./order-image-preview.vue?vue&type=script&lang=js"
export * from "./order-image-preview.vue?vue&type=script&lang=js"
import style0 from "./order-image-preview.vue?vue&type=style&index=0&id=0da6bc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da6bc12",
  null
  
)

export default component.exports